import { useEffect } from "react";

function Map() {
  return (
    <section className="map">
      <h2>LOCATION</h2>
      <p className="address">1921 Osborne Rd, St Marys, GA 31558</p>
      <div className="iframe-map-wrapper">
       <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3455.196949119108!2d-81.5540973!3d30.7446436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e61b6cfaefb27f%3A0xa0bd14c76458b6aa!2s1921%20Osborne%20Rd%2C%20St%20Marys%2C%20GA%2031558!5e0!3m2!1sen!2sus!4v1691234567890!5m2!1sen!2sus"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          title="Welcome Inn Location"
        />

      </div>
    </section>
  );
}

export default Map;

